import { Component, type ErrorInfo, type ReactNode } from 'react';
import {
  isChunkLoadError,
  tryReloadForChunkError,
} from '../utils/chunkLoadRecovery';

type Props = { children: ReactNode };
type State = { failed: boolean };

/**
 * Catches React.lazy() failures when a release removed old hashed chunks.
 * Reloads once so the browser picks up the new index.html asset map.
 */
export default class ChunkLoadErrorBoundary extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(error: Error): Partial<State> | null {
    if (isChunkLoadError(error)) {
      return { failed: true };
    }
    return null;
  }

  componentDidCatch(error: Error, _info: ErrorInfo): void {
    if (isChunkLoadError(error)) {
      tryReloadForChunkError();
    }
  }

  render() {
    if (this.state.failed) {
      return null;
    }
    return this.props.children;
  }
}
